import React, { useEffect, useState } from "react";
import { getIconsApi } from "../../api";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { setIcons } from "../../redux";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { 
  FiArrowLeft, 
  FiMove, 
  FiClock, 
  FiList, 
  FiInfo, 
  FiEdit, 
  FiBookOpen,
  FiSettings
} from "react-icons/fi";

const WidgetSettingComp = (props) => {
  const { t } = useTranslation();
  const {
    zone,
    toggleCommands,
    toggleScheduleList,
    toggleEdit,
    toggleMove,
    toggleInfo,
    toggleDeviceInfo,
    toggleLearn,
  } = props;
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    getIconsApi(token)
      .then((res) => {
        dispatch(setIcons(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  }, []);

  const menuItems = [
    {
      key: "move",
      label: t("انتقال به اتاق دیگر"),
      icon: <FiMove size={18} />,
      onClick: toggleMove,
    },
    {
      key: "scheduling",
      label: t("زمانبندی"),
      icon: <FiClock size={18} />,
      onClick: toggleCommands,
    },
    {
      key: "scheduleList",
      label: t("لیست زمانبندی ها"),
      icon: <FiList size={18} />,
      onClick: toggleScheduleList,
    },
    {
      key: "widgetInfo",
      label: t("اطلاعات ویجت"),
      icon: <FiInfo size={18} />,
      onClick: toggleInfo,
    },
    {
      key: "editWidget",
      label: t("ویرایش ویجت"),
      icon: <FiEdit size={18} />,
      onClick: toggleEdit,
    },
  ];

  // Add Learn option for specific widget types
  if (zone.property[0] === "Widget4" || zone.property[0] === "Widget5") {
    menuItems.push({
      key: "learn",
      label: t("لرن و حذف لرن"),
      icon: <FiBookOpen size={18} />,
      onClick: toggleLearn,
    });
  }

  return (
    <div className="setting-container" style={{ minHeight: "auto", padding: "24px" }}>
      <h2 className="setting-title">{t("تنظیمات ویجت")}</h2>
      
      {/* Zone Name */}
      <div className="widget-zone-info">
        <p className="widget-zone-name">{zone.caption}</p>
      </div>

      {/* Menu Items */}
      <div className="widget-settings-list">
        {menuItems.map((item) => (
          <div
            key={item.key}
            className="widget-setting-item"
            onClick={item.onClick}
          >
            <div className="widget-setting-label">
              {item.icon}
              <span>{item.label}</span>
            </div>
            <div className="widget-setting-arrow">
              <FiArrowLeft size={16} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const WidgetSetting = withRouter(WidgetSettingComp);

export { WidgetSetting };